import React from 'react';
import './ui.css';

const Card = ({
    children,
    title,
    extra,
    padding = 'var(--spacing-6)',
    className = '',
    noBorder = false,
    ...props
}) => {
    return (
        <div className={`saas-card ${noBorder ? 'no-border' : ''} ${className}`} style={{ '--card-padding': padding }}>
            {(title || extra) && (
                <div className="saas-card-header">
                    {title && <h3 className="saas-card-title">{title}</h3>}
                    {extra && <div className="saas-card-extra">{extra}</div>}
                </div>
            )}
            <div className="saas-card-body">
                {children}
            </div>
        </div>
    );
};

export default Card;
